import { TextButton } from 'sharedComponents/Buttons';
import { connectRedirectUrls } from 'utils/constants/urls';
import { CONNECT_JOBBOARD_STATES } from 'utils/constants/connect';
import { NAVBAR_BUTTON_LABELS } from 'utils/constants';
import { secondaryButtonStyles } from './styles';
import { createButtonUrl } from 'features/Connect/features/ExpressInterest/utils';
import { useHistory } from 'react-router-dom';
import { NavBarButtonProps } from '../types';

export const LoginButton: React.FC<NavBarButtonProps> = ({ jobBoardState }) => {
  const history = useHistory();

  const handleLoginRedirect = () => {
    history.push(
      createButtonUrl({
        basePath: connectRedirectUrls.LOGIN,
        jobboardState: CONNECT_JOBBOARD_STATES[jobBoardState].urlParam,
      })
    );
  };
  return (
    <TextButton onClick={handleLoginRedirect} sx={secondaryButtonStyles}>
      {NAVBAR_BUTTON_LABELS.LOGIN}
    </TextButton>
  );
};
